<script setup>
import PhoneCallTable from '@frontJs/components/tables/projectManagement/apikom/PhoneCallTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { useRoute } from '@js/utils/route';
import { h, onMounted, ref } from 'vue';

const { route } = useRoute();

const loading = ref(true);

const data = ref({
    toProcess: 0,
});

function updateData() {
    loading.value = true;

    Promise.all([
        axios.post(route('front.projectManagement.apikom.postPhoneCallCount'), {
            status: 'to_process',
        }),
    ])
        .then((response) => {
            data.value.toProcess = response[0].data.count;
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            loading.value = false;
        });
}

onMounted(() => {
    updateData();
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>Appels - Apikom - Gestion de projet - Datakepler</title>
    </Head>

    <PageTitle> Gestion de projet - Apikom - Appels </PageTitle>

    <TabLayout
        :tabs="{
            toProcess: {
                title: 'À traiter',
                total: data.toProcess,
                content: h(PhoneCallTable, {
                    status: 'to_process',
                    callback: updateData,
                }),
            },
            validated: {
                title: 'Validés',
                content: h(PhoneCallTable, {
                    status: 'validated',
                    callback: updateData,
                }),
            },
            ignored: {
                title: 'Ignorés',
                content: h(PhoneCallTable, {
                    status: 'ignored',
                    includeMissed: true,
                    callback: updateData,
                }),
            },
            missed: {
                title: 'Manqués',
                content: h(PhoneCallTable, {
                    status: 'to_process',
                    type: 'missed',
                    callback: updateData,
                }),
            },
        }"
        :loading="loading"
    />
</template>
